import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateUserEmailParams {
  userId: string; // server user id
  email: string;
}

export class UpdateUserEmailRequest extends Request<IUpdateUserEmailParams, IResult> {
  constructor(params: IUpdateUserEmailParams) {
    super('updateUserEmail', params);
  }
}
